import type { Theme } from "@material-ui/core";
import { Box, createStyles, makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.primary.dark,
      marginBottom: "1em",
    },
    caption: {
      color: theme.palette.secondary.dark,
    },
    left: {
      justifyContent: "flex-start !important",
    },
    right: {
      justifyContent: "flex-end !important",
    },
  }),
);

interface MessageProps {
  id?: string;
  message: string;
  caption: string;
  className: string;
}

const Message = ({ id, message, caption, className }: MessageProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Box key={id} width={200}>
      <Box borderRadius={5} p={2} className={clsx(classes.root, className)}>
        <Typography variant="body1">{message}</Typography>
      </Box>
      <Typography variant="caption" className={classes.caption}>
        {caption}
      </Typography>
    </Box>
  );
};

export default Message;
